// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HSkqN","input":"styles_input__YaBUk","label":"styles_label__nU-KR","error":"styles_error__HsJqW"};